export const isProduction = process.env.APP_ENV === 'production';
